export default {
  SEARCH_PLACEHOLDER_ASYNC: 'Search - Displaying 50 Max',
  SEARCH_PLACEHOLDER: 'Search',
};
